function getFocusableElements(container) {
  if (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.tabIndex = 0;
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.addEventListener('focus', (event) => {
    if (!summary.closest('header-drawer')) {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('keyup', (e) => {
      if (e.key.toUpperCase() == 'ENTER') {
        this.onSummaryClick.bind(this)
      }
    }))
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const parentUtilityLinks = document.querySelector('[data-main-utility-links]')

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        detailsElement.setAttribute('open', true)
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        parentUtilityLinks.classList.add('hidden')
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      this.mainDetailsToggle.setAttribute('open', true)
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    const parentUtilityLinks = document.querySelector('[data-main-utility-links]')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    parentUtilityLinks.classList.remove('hidden')
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    var event = new CustomEvent("modal-popup:open", { "detail": this });
    document.dispatchEvent(event);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = Array.from(this.slider.children).filter(child => child.id.startsWith('Slide-'));
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.buttonsContainer = Array.from(this.children).find(child => child.tagName === 'DIV' && child.classList.contains('slider-buttons'));
    this.prevButton = this.buttonsContainer ? this.buttonsContainer.querySelector('button[name="previous"]') : null;
    this.nextButton = this.buttonsContainer ? this.buttonsContainer.querySelector('button[name="next"]') : null;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

    // Disable buttons if there is only one slide
    if (this.sliderItemsToShow.length <= 1) {
        this.totalPages = 1;
        this.prevButton && this.prevButton.setAttribute('disabled', 'disabled');
        this.nextButton && this.nextButton.setAttribute('disabled', 'disabled');
        return;
    }

    // If more than one slide, proceed with calculations and enable buttons
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    // Enable buttons if they were disabled previously
    this.prevButton && this.prevButton.removeAttribute('disabled');
    this.nextButton && this.nextButton.removeAttribute('disabled');

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.currentVariantId = this.getAttribute('data-current-variant-id');
    this.colorLabel = this.querySelector('[data-selected-color]');
    this.addEventListener('change', evt => {
      this.onVariantChange(evt)
    });

    // if is a product recommendations card item
    this.isProductCard = this.closest(".card") ? true : false
    if (this.isProductCard) {
      this.productCard = this.closest(".card");
      this.cardATC = this.productCard.querySelector('[data-card-atc]');
      this.closeOptionModalBtn = this.productCard.querySelector('[data-option-modal-close]');
      this.colorLabel = this.productCard.querySelector('[data-selected-color]');
      this.cardContentBottom = this.productCard.querySelector('.card__content.card__content--bottom');

      if (this.cardContentBottom) {
        this.cardContentBottom.classList.add('is-active');
      }
    
      if (this.cardATC) {
        this.cardATC.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.toggleOptionsModal();
        };
      }
    
      if (this.closeOptionModalBtn) {
        this.closeOptionModalBtn.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.toggleOptionsModal();
        };
      }

      this.updateOcpGating();
    }
  }

  onVariantChange(evt) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.updateColorLabel();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.updateAvailability();
      this.setUnavailable();
    } else {
      this.updateAvailability();
      this.updateMedia(evt);
      this.updateSoldOut(this.currentVariant);
      this.updateVariantInput();

      if (!this.isProductCard) {
        this.updateURL();
        this.renderProductInfo();
        this.updateShareUrl();
        this.groupMediaByColor();
      }
    }

    this.updateOcpGating();
  }

  updateOcpGating() {
    if (!window.ocpGating || !window.ocpGating.enabled) return;

    let variant = this.currentVariant;
    if (!variant && this.currentVariantId) {
      try {
        variant = this.getVariantData().find(v => v.id === parseInt(this.currentVariantId));
      } catch(e) { /* variant data not available yet */ }
    }
    if (!variant) return;

    const isGated = variant.option1 === window.ocpGating.color || variant.option2 === window.ocpGating.color || variant.option3 === window.ocpGating.color;

    const parent = this.closest('section') || this.closest('.card');
    if (!parent) return;

    const gatingBtn = parent.querySelector('[data-ocp-gating-btn]');
    const productForm = parent.querySelector('product-form');
    if (gatingBtn) gatingBtn.style.display = isGated ? '' : 'none';
    if (productForm) productForm.style.display = isGated ? 'none' : '';

    if (this.isProductCard && this.cardATC) {
      const cardGatingBtn = this.productCard.querySelector('[data-ocp-card-gating-btn]');
      if (cardGatingBtn) {
        cardGatingBtn.style.display = isGated ? '' : 'none';
        this.cardATC.style.display = isGated ? 'none' : '';
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateColorLabel() {
    if(!this.colorLabel || !this.currentVariant) return;
    const colorPos = Number(this.colorLabel.getAttribute('data-color-pos'));
    this.colorLabel.textContent = this.currentVariant.options[colorPos];
  }

  toggleOptionsModal() {
    this.optionsModal = this.productCard.querySelector('[data-card-option-modal]');
  
    let modalOverlay = document.querySelector('.modal-overlay');
    if (!modalOverlay) {
      modalOverlay = document.createElement('div');
      modalOverlay.className = 'modal-overlay';
      document.body.appendChild(modalOverlay);
    }
  
    if (this.optionsModal) {
      // Close all other open modals
      const openModals = document.querySelectorAll('[data-card-option-modal].open');
      openModals.forEach(modal => {
        if (modal !== this.optionsModal) {
          modal.classList.remove('open');
        }
      });
  
      const isOpen = this.optionsModal.classList.toggle('open');
  
      if (window.innerWidth <= 750) {
        if (isOpen) {
          // Capture the current scroll position
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          modalOverlay.style.display = 'block';
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          // Apply the top offset to keep the position
          document.body.style.top = `-${scrollY}px`;
          document.body.style.width = '100%';
          document.documentElement.style.overflow = 'hidden';
        } else {
          modalOverlay.style.display = 'none';
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.documentElement.style.overflow = '';
  
          // Restore the scroll position
          const scrollY = document.body.style.top;
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
      } else {
        modalOverlay.style.display = 'none';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.documentElement.style.overflow = '';
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (this.currentVariant) this.container.setAttribute('data-current-variant-id', this.currentVariant.id);
  }

  updateMedia(evt) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    //  Check whether the option swatch that the user just clicked is a color swatch or not.
    let clickedSwatch = evt.target
    let isColorSwatch = clickedSwatch?.closest(`[data-option-name="color"]`)
     
    if (mediaGallery) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, isColorSwatch);
    }

    if (this.isProductCard) {
      const cardImage = this.productCard.querySelector('.card__media img');
      if (cardImage) {
        const newImageUrl = this.currentVariant.featured_media.preview_image.src;
        const newImageWidth = this.currentVariant.featured_media.width;
      
        // Update src
        cardImage.setAttribute('src', newImageUrl);
      
        // Build and update srcset
        const srcsetSizes = [165, 360, 533, 720, 940, 1066];
        const srcset = srcsetSizes.map(size => {
          if (newImageWidth >= size) {
            return `${newImageUrl}?&width=${size} ${size}w`;
          }
          return null;
        }).filter(url => url != null).join(", ");
      
        cardImage.setAttribute('srcset', srcset);
      }      
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  groupMediaByColor() {
    let context = document.querySelector(`[data-section="${this.dataset.section}"`);
    let imgs = context.querySelectorAll('[data-group]');

    if (imgs.length === 0) return;

    imgs.forEach((item, i) => {
      let color = item.dataset.group;

      if ( !color ) return false;

      let currentColor = this.currentVariant.option1.replace(/\W+/g, '-').toLowerCase();
      
      if (color == currentColor) {
        item.classList.remove('group_image--hide');
      } else {
        item.classList.add('group_image--hide');
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateAvailability() {
    const prodAvailability = document.querySelector('[data-product-availability]');
    if (!prodAvailability) return;
    const varQty = this.currentVariant?.inventory_quantity ?? 0;
    const availLimit = parseInt(prodAvailability.dataset.productAvailability);

    let message_under_threshold = window.message_under_threshold.replace('[[amount]]', varQty)
    let message_over_threshold = window.message_over_threshold

    let availability_message = document.querySelector('[data-availability-message]')
    if (varQty >= 1 && varQty <= availLimit) {
      prodAvailability.style.display = "block"
      availability_message ? availability_message.innerText = message_under_threshold : null
    }else if(varQty >= 1 && varQty > availLimit){
      prodAvailability.style.display = "block"
      availability_message ? availability_message.innerText = message_over_threshold : null
    }else if(varQty < 1) {
      prodAvailability.style.display = "none"
    }
  }

  updateSoldOut(variant) { 
    const inputs = this.container.querySelectorAll("[type=radio]");
  
    const states = {
      sold_out: function (element) {
        element.parentElement.classList.add("soldout");
      },
      available: function (element) {
        element.parentElement.classList.remove("soldout");
      }
    };
  
    inputs.forEach((input) => { 
      let currentVariant;
      if (!this.currentVariant) {
        currentVariant = variant;
      } else {
        currentVariant = this.currentVariant;
      }
  
      const optionPosition = input.getAttribute("data-position");
      const currentOption = "option" + optionPosition;
      const otherOptions = ["option1", "option2", "option3"].filter(option => option !== currentOption);
  
      // Get the color of the current variant
      const currentColor = currentVariant.option1;
  
      // Check if all sizes for the current color are unavailable
      const allSizesUnavailable = this.variantData
        .filter(productVariant => productVariant.option1 === currentColor)
        .every(productVariant => !productVariant.available);
  
      if (allSizesUnavailable) {
        console.log(`All sizes for color ${currentColor} are sold out`);
        states.sold_out(input);
      } else {        
        states.available(input);
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }  
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions();

    this.optionModals = this.closest('.card')?.querySelectorAll('[data-card-option-modal]');
    this.optionModalConfirms = this.closest('form')?.querySelectorAll('[data-option-modal-confirm]');
    if (this.optionModalConfirms) {
        this.optionModalConfirm();
    }

    if(this.optionModals){
      this.optionModals.forEach(modal => {
          this.deselectOptions(modal);
          this.setupOptionSelection(modal);
      });
    }
  }

  deselectOptions(modal) {
      const options = modal.querySelectorAll(`[data-option-name="size"] input[type="radio"], [data-option-name="length"] input[type="radio"]`);
      options.forEach(option => {
          option.classList.add('visually-unchecked');
          option.addEventListener('click', () => {
              option.classList.remove('visually-unchecked');
          });
      });

      const confirmButton = modal.querySelector('[data-option-modal-confirm]');
      if (confirmButton) {
          confirmButton.setAttribute('disabled', 'true');
      }
  }

  setupOptionSelection(modal) {
    const sizeOptions = modal.querySelectorAll('[data-option-name="size"] input[type="radio"]');
    const lengthOptions = modal.querySelectorAll('[data-option-name="length"] input[type="radio"]');
    const confirmButton = modal.querySelector('[data-option-modal-confirm]');
    const nextArrow = modal.querySelector('.slider-button--next');

    const updateSelectionState = (options, optionName) => {
        options.forEach(option => {
            option.addEventListener('click', () => {
                // Adding visual state change
                options.forEach(opt => {
                    if (opt !== option) {
                        opt.classList.add('visually-unchecked');
                    }
                });

                checkOptions();

                // Auto navigate to the next option if size is selected
                if (optionName === 'size' && nextArrow) {
                    nextArrow.click();
                }
            });
        });
    };

    const checkOptions = () => {
        const isSizeSelected = sizeOptions.length === 0 || Array.from(sizeOptions).some(option => !option.classList.contains('visually-unchecked'));
        const isLengthSelected = lengthOptions.length === 0 || Array.from(lengthOptions).some(option => !option.classList.contains('visually-unchecked'));

        if (isSizeSelected && isLengthSelected) {
            confirmButton.removeAttribute('disabled');
        } else {
            confirmButton.setAttribute('disabled', 'true');
        }
    };

    updateSelectionState(sizeOptions, 'size');
    updateSelectionState(lengthOptions, 'length');
  }

  optionModalConfirm() {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const isCartPage = window.location.pathname === '/cart';

    this.optionModalConfirms.forEach(optionModalConfirm => {
      optionModalConfirm.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (window.ocpGating && window.ocpGating.enabled) {
          const colorInput = optionModalConfirm.closest('form')?.querySelector('[data-option-name="color"] input:checked');
          if (colorInput && colorInput.value === window.ocpGating.color) {
            window.location.href = window.ocpGating.redirectUrl || '/pages/government-contracts';
            return;
          }
        }

        const modal = optionModalConfirm.closest('[data-card-option-modal]');
        const form = optionModalConfirm.closest('form');
        if (form) {
          const variantRadios = form.querySelector('variant-radios');
          const variantId = variantRadios ? variantRadios.getAttribute('data-current-variant-id') : null;

          if (variantId) {
            const items = [{ id: variantId, quantity: 1 }];
            let payload = { items };

            if (!isCartPage) {
              const sections = this.cart.getSectionsToRender().map((section) => section.id);
              const sections_url = window.location.pathname;
              payload.sections = sections;
              payload.sections_url = sections_url;
            }

            const config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            };

            try {
              const response = await fetch('/cart/add.js', config);
              const cartResponse = await response.json();

              if (isCartPage) {
                window.location.reload();
              } else {
                this.openAddToBagModal(cartResponse);

                try {
                  this.cart.renderContents(cartResponse);
                } catch (error) {
                  console.error('Error fetching updated cart:', error);
                }

                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

                // Reset the options to deselected
                this.deselectOptions(modal);
              }
            } catch (error) {
              console.error('Error adding item to cart:', error);
            }
          } else {
            console.error('Variant ID not found');
          }
        }
      });
    });   
  }

  openAddToBagModal(items) {
    const item = items.items[0];
    const itemPrice = item.price / 100;
    this.optionModals.forEach(optionModal => {
      optionModal.classList.remove('open');
    });
  
    let modalOverlay = document.querySelector('.modal-overlay');
    if (!modalOverlay) {
      modalOverlay = document.createElement('div');
      modalOverlay.classList.add('modal-overlay');
      document.body.appendChild(modalOverlay);
    }
  
    const modal = document.createElement('div');
    modal.classList.add('modal');
    modal.innerHTML = `
      <div class="modal-content">
        <span class="close-modal">&times;</span>
        <div class="modal-header">ADDED TO BAG</div>
        <div class="modal-body">
          <img src="${item.image}" class="modal-image" alt="${item.product_title}">
          <p class="modal-title">
            ${item.product_title}
          </p>
          <p class="modal-price">
            $${itemPrice.toFixed(2)}
          </p>
          <p class="modal-variant">${item.variant_title.replace(' / ', ' ')}</p>
        </div>
        <div class="modal-footer">
          <button class="modal-checkout">
            CHECKOUT
          </button>
        </div>
      </div>
    `;
  
    modalOverlay.appendChild(modal);
    modalOverlay.style.display = 'block';
    modalOverlay.style.zIndex = 9999999999;
  
    if (window.innerWidth <= 750) {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden'; // Lock the HTML scroll
    }
  
    function closeModal() {
      modalOverlay.style.display = 'none';
      modalOverlay.style.zIndex = 1000;
      modalOverlay.removeChild(modal); // Remove the modal from the overlay
  
      if (window.innerWidth <= 750) {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = ''; // Unlock the HTML scroll
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
  
    const closeModalButton = modal.querySelector('.close-modal');
    closeModalButton.addEventListener('click', closeModal);
  
    modalOverlay.addEventListener('click', (event) => {
      if (event.target === modalOverlay) {
        closeModal();
      }
    });
  
    modal.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  
    const checkoutButton = modal.querySelector('.modal-checkout');
    checkoutButton.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }  

  // Overwrite updateOptions method to check for unavailable variants
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const radio = Array.from(fieldset.querySelectorAll('input')).find((radio) => {
          return radio.checked;
      });
      return radio ? radio.value : null;
    });
    const possibleVariants = this.getVariantData().filter(variant => variant.option1 === this.options[0]);
    
    for (let index = 0; index < possibleVariants.length; index++) {
      const variant = possibleVariants[index]
      if (variant.id === parseInt(this.currentVariantId)) {
        this.updateSoldOut(variant);
        break;
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();

    this.triggerSection = this.parentElement.querySelector('.product-form__buttons');


    this.toggleStickyBar()

    document.addEventListener("scroll", debounce(() => {
      this.toggleStickyBar()
    }));
  }

  toggleStickyBar() {
    let lastKnownScrollPosition = window.scrollY;
    let scrollTriggerPosition =  this.triggerSection.getBoundingClientRect().top;

    if (scrollTriggerPosition != 0) {
      if (scrollTriggerPosition < 0 ) {
        this.style.opacity = 1;
        this.style.zIndex = 4;
        document.querySelector('footer').style.marginBottom = this.offsetHeight + 'px'
      } else {
        this.style.opacity = 0;
        this.style.zIndex = -2;
        document.querySelector('footer').style.marginBottom = 0
      }
    }
  }
}

customElements.define("product-sticky-bar", ProductStickyBar);

document.addEventListener('DOMContentLoaded', e => { 
  let scrollpos = sessionStorage.getItem('scrollpos');
  if (scrollpos) {
    window.scrollTo(0, scrollpos);
    sessionStorage.removeItem('scrollpos');
  }
});


if (!customElements.get('video-controls')) {
  customElements.define(
    'video-controls',
    class VideoControls extends HTMLElement {
      constructor() {
        super()
        this.sectionID = this.getAttribute('data-section-id');
        this.section = document.querySelector(`#Banner-${this.sectionID}`)
        this.videos = this.section.querySelectorAll('video');
        this.playPauseButton = this.section.querySelector('button[data-play-pause]')
        this.init()
      }

      init() {
        this.playPauseButton.addEventListener('click', this.playPause.bind(this))
      }

      playPause(e){
        let action = e.currentTarget.getAttribute('data-play-pause');
        this.videos.forEach(video => {
          if(action == "pause"){
            video.pause();
            e.currentTarget.setAttribute('data-play-pause', 'play')
          }else {
            video.play();
          }
        })
        action == "pause" 
        ? e.currentTarget.setAttribute('data-play-pause', 'play')
        : e.currentTarget.setAttribute('data-play-pause', 'pause')
      }

    }
  )
}
